
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, OnInit, forwardRef, ChangeDetectionStrategy, ChangeDetectorRef, inject } from "@angular/core";
import { TaskOptionComponent } from "../task-option.component";
import { TaskRepository } from "../../../../repository/task.repository";
import { MatDialog } from "@angular/material/dialog";
import { MatList, MatListItem } from "@angular/material/list";
import { MatIcon } from "@angular/material/icon";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "vp-vnctask-option-add-repeats",
    providers: [{
            provide: TaskOptionComponent,
            // eslint-disable-next-line
            useExisting: forwardRef(() => TaskAddRepeatsComponent)
        }],
    templateUrl: "options-add-repeats.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatList, MatListItem, MatIcon, TranslatePipe]
})
export class TaskAddRepeatsComponent extends TaskOptionComponent implements OnInit {
  private taskRepo = inject(TaskRepository);
  override changerDetectorRef: ChangeDetectorRef;
  override matDialog: MatDialog;

  override id: string = "add-repeats";
  override triggerKey: string = "*";
  repeats: any = {
    name: "repeats",
    value: ""
  };

  constructor() {
    const changerDetectorRef = inject(ChangeDetectorRef);
    const matDialog = inject(MatDialog);

    super();

    this.changerDetectorRef = changerDetectorRef;
    this.matDialog = matDialog;
  }

  ngOnInit() {
    let items = this.taskRepo.getRepeatItems();
    this.setItems(items);
  }

  override getPayload() {
    let value = this.getValue();
    if (!value || (value && !value.value) || (value.value === "n")) {
      return {};
    }
    return { repeats: value.value };
  }

}
